import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import {
    RouteWithLayout,
} from './components';

import {
    Minimal as MinimalLayout
} from './layouts';

import {
    Methodology as MethodologyPage,
    CopPlatform as CopPlatformPage,
    NationalCPC as NationalCPCPage,
    GlobalCPC as GlobalCPCPage,
    GlobalCPCTest as GlobalCPCTestPage,
    PrivacyPolicy as PrivacyPolicyPage,
    NotFound as NotFoundPage
} from './pages';

const Routes = () => {
    return (
        <Switch>
            <Redirect
                exact
                from="/"
                to="/global_cpc"
            />

            <RouteWithLayout
                component={MethodologyPage}
                exact
                layout={MinimalLayout}
                path="/methodology"
            />

            <RouteWithLayout
                component={CopPlatformPage}
                exact
                layout={MinimalLayout}
                path="/cop_platform"
            />

            <RouteWithLayout
                component={NationalCPCPage}
                exact
                layout={MinimalLayout}
                path="/national_cpc"
            />

            <RouteWithLayout
                component={GlobalCPCPage}
                exact
                layout={MinimalLayout}
                path="/global_cpc"
            />

            <RouteWithLayout
                component={GlobalCPCTestPage}
                exact
                layout={MinimalLayout}
                path="/global_cpc_test"
            />

            <RouteWithLayout
                component={PrivacyPolicyPage}
                exact
                layout={MinimalLayout}
                path="/privacy"
            />

            <RouteWithLayout
                component={NotFoundPage}
                exact={false}
                layout={MinimalLayout}
                path="/"
            />



        </Switch>
    );
};

export default Routes;